export default "__VITE_ASSET__9kFRc8$7__"